module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel5-en@2x-0af41e3fe8f01819ed37eb1fccd4e93b.png";